import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { CustomCard } from "../../CustomCard";
import { CreditCardIcon } from "../../../../assets";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const FeesCard = ({ handleShow, data, handleEditModal }) => {
  const { svcfee_name, svcfee_desc, svcfee_amt } = data;
  const [showMore, setShowMore] = useState(false);

  const shouldText = svcfee_desc.length > 100;
  const displayText = showMore
    ? svcfee_desc
    : `${svcfee_desc.slice(0, 100)}${shouldText ? "..." : ""}`;

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <CustomCard className="facility">
      <div
        className="d-flex justify-content-between align-items-start !pb-3 !mb-4"
        style={{ borderBottom: "1px solid #E7E7E9" }}
      >
        <div className="d-flex align-items-center justify-content-center gap-2">
          <div className="min-w-[30px] w-[30px] h-[30px] rounded-5 border-slate-300 align-items-center justify-content-center d-flex bankCard_creditCardIcon">
            <CreditCardIcon />
          </div>
          <div>
            <h6 className="card-title mb-0">{svcfee_name}</h6>
            {/* <small>#{user_profile_id}</small> */}
          </div>
        </div>
        <div className="icons mb-0">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Edit Fees</Tooltip>}
          >
            <Icon
              icon="fluent:edit-48-filled"
              onClick={() => handleEditModal(data)}
              color="red"
              className="cursor-pointer"
            />
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Delete Fees</Tooltip>}
          >
            <Icon
              icon="mingcute:delete-fill"
              onClick={handleShow}
              color="red"
              className="cursor-pointer"
            />
          </OverlayTrigger>
        </div>
      </div>
      <p className="!text-[14px] !text-[#767676] !font-normal !leading-[19px]">
        {displayText}
        {shouldText && (
          <span onClick={toggleShowMore}>
            {" "}
            {showMore ? "Show Less" : "Show More"}
          </span>
        )}
      </p>

      <div className="row gap-y-[18px]">
        <div className="col-6">
          <small>Fee Amt USD:</small>
          <p className="truncate mb-0">${svcfee_amt}</p>
        </div>
      </div>
    </CustomCard>
  );
};
